<template>
    <v-container flat>
        <v-row no-gutters class="my-3 justify-center">
            <v-col cols="2">
                <v-btn-primary
                    block
                    @click="addAccountingPeriod"
                    id="AddAccountingPeriodAccountingPeriods"
                    :disabled="!isAuthorized"
                    data-cy="AccountingPeriods-add"
                >
                    Ajouter
                </v-btn-primary>
            </v-col>
            <v-col cols="10" class="pl-2">
                <!-- <v-text-field
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details dense
                ></v-text-field> -->
            </v-col>
        </v-row>
        <!-- <v-card-text> -->
        <!-- <v-layout wrap>
                <v-flex xs8>
                    <h1>{{ $t('settings.accountingPeriod') }}</h1>
                </v-flex>
                <v-flex xs4 class="d-flex justify-end">
                    <v-btn
                        color="secondary"
                        rounded
                         size="small"

                        elevation= "0"
                        @click="accountingPeriodDialog = true; selectedAccountingPeriodId = ''"
                    >
                        <v-icon>$add</v-icon> {{ $t('shared.add') }}
                    </v-btn>
                </v-flex> -->

        <AccountingPeriodsSuiteErrors
            v-if="accountingPeriodsSuiteErrors && accountingPeriodsSuiteErrors.length"
            :accountingPeriodsSuiteErrors="accountingPeriodsSuiteErrors"
        />

        <AccountingPeriodsMissingLaps
            v-if="missingAccountingPeriodLaps && missingAccountingPeriodLaps.length"
            :missingAccountingPeriodLaps="missingAccountingPeriodLaps"
        />

        <v-row
            no-gutters
            v-if="displayAccountingPeriods && displayAccountingPeriods.length"
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-col
                :cols="$vuetify.display.mobile ? '12' : '8'"
                class="pa-2"
                v-for="ap in displayAccountingPeriods"
                :key="ap.id"
            >
                <v-card
                    class="default_card ma-0"
                    elevation="0"
                    pa-0
                    style="margin: 5px"
                    @click="openAccountingPeriod(ap)"
                >
                    <v-row class="d-flex align-center" no-gutters>
                        <!-- ** icon -->
                        <v-col
                            cols="1"
                            class="d-flex justify-center align-center"
                            v-if="!$vuetify.display.mobile"
                        >
                            <v-icon color="secondary" class="icon" size="x-large">
                                $date_range
                            </v-icon>
                        </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <!-- ** dates -->
                        <v-col :cols="$vuetify.display.mobile ? '8' : '7'">
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center justify-start">
                                    <span
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="font-weight: bold; font-size: 16pt"
                                    >
                                        {{ formatDate(ap.start) }} - {{ formatDate(ap.end) }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center justify-start">
                                    <template
                                        v-if="
                                            ap.manualCarryForwards && ap.manualCarryForwards.length
                                        "
                                    >
                                        <!-- <strong style="color:red;">Utiliser les AN de bobbee dans des exercices intermédiaires</strong> -->
                                        <strong style="color: red" v-if="ap.carryForwardCount">
                                            Doublon avec le Report à de nouveau de bobbee</strong
                                        >
                                        <strong style="color: green" v-else
                                            >Report à nouveau manuel présent</strong
                                        >
                                    </template>
                                    <strong style="color: red" v-else-if="!ap.carryForwardCount"
                                        >Report à nouveau manquant</strong
                                    >
                                    <strong
                                        style="color: red"
                                        v-else-if="autoCarryForwardToDelete(ap)"
                                        >Report à nouveau bobbee présent à supprimer</strong
                                    >
                                    <strong style="color: green" v-else
                                        >Report à nouveau bobbee présent</strong
                                    >
                                </v-col>
                            </v-row>
                        </v-col>

                        <!-- ** lock -->
                        <v-col cols="1" class="d-flex justify-center align-center">
                            <v-icon size="x-large" v-if="ap.closed" class="px-1"
                                >$lock_outline</v-icon
                            >
                        </v-col>

                        <!-- ** trash -->
                        <v-col cols="1" class="d-flex justify-center align-center">
                            <template v-if="isAuthorized">
                                <div v-if="ap.isDeletable && ap.isDeletable.length">
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <div>
                                                <v-btn-trash disabled v-bind="props" />
                                            </div>
                                        </template>

                                        <span>
                                            <AccountingPeriodIsDeletable
                                                :isDeletable="ap.isDeletable"
                                            />
                                        </span>
                                    </v-tooltip>
                                </div>

                                <template v-else>
                                    <v-btn-trash
                                        @click.stop="openDeleteAccountingPeriodDialog(ap)"
                                        :data-cy="'AccountingPeriods-trash-' + ap.id"
                                    />
                                </template>
                            </template>
                        </v-col>

                        <!-- <v-col cols="1" v-if="ap.closed === true" class="d-flex justify-center align-center">
                                <v-icon color="secondary">lock_outline</v-icon>
                            </v-col>
                            <v-col cols="1" v-else-if="ap.temporaryClosed === true" class="d-flex justify-center align-center">
                                <v-icon color="secondary">lock_outline</v-icon>
                                <div>Provisoire</div>
                            </v-col> -->

                        <!-- ** edit -->
                        <v-col cols="1" class="d-flex justify-center align-center">
                            <v-btn-icon
                                icon="$edit"
                                color="secondary"
                                :data-cy="'AccountingPeriods-edit-' + ap.id"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row no-gutters v-else class="d-flex justify-center">
            <v-col :cols="$vuetify.display.mobile ? '12' : '8'" class="my-0 pa-2">
                <v-card class="default_card ma-0" elevation="0" pa-0 style="margin: 5px">
                    <v-row class="d-flex align-center" no-gutters>
                        <v-col cols="2" class="py-3" v-if="!$vuetify.display.mobile">
                            <v-icon color="new_red" class="icon" size="x-large">
                                $date_range
                            </v-icon>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '10' : '8'">
                            <div class="d-flex align-center primary--text">
                                <span
                                    :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                    style="font-weight: bold; font-size: 16pt"
                                >
                                    Aucun exercice comptable
                                </span>
                            </div>
                            <div class="d-flex align-center">
                                <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                    Vous n'avez enregistré aucun exercice comptable
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- </v-layout> -->
        <!-- </v-card-text> -->
        <!-- <v-dialog
                v-model="accountingPeriodDialog"
                width="50%"
            > -->
        <AccountingPeriod
            v-model="accountingPeriodDialog"
            v-if="accountingPeriodDialog"
            :id="selectedAccountingPeriodId"
            :accountingPeriod="selectedAccountingPeriod"
            :accountingPeriods="ligthAccountingPeriods"
            :carryForwardDiagnostic="selectedCarryForwardDiagnostic"
            :prevAccountingPeriod="getPrevAccountingPeriod(selectedCarryForwardDiagnostic)"
            :companyId="companyId"
            :missingAccountingPeriodLaps="missingAccountingPeriodLaps"
            :accountingPeriodsSuiteErrors="accountingPeriodsSuiteErrors"
            @upsert="refresh(false)"
        />

        <!-- </v-dialog> -->
        <oss-dialog
            v-model="deleteAccountingPeriodDialog"
            :title="'Suppression de l\'exercice'"
            v-if="selectedAccountingPeriod"
            :error="true"
            :validTitle="`Supprimer l\'exercice du ${formatDate(
                selectedAccountingPeriod.start,
            )} au ${formatDate(selectedAccountingPeriod.end)}`"
            @valid="deleteAccountingPeriod"
            :validLoading="deleteAccountingPeriodLoading"
            prefixDataCy="ossFilterBar-delete"
            width="800px"
        >
            <h4 class="text-center">
                &#xca;tes-vous sûr(e) de vouloir supprimer l'exercice du
                {{ formatDate(selectedAccountingPeriod.start) }} au
                {{ formatDate(selectedAccountingPeriod.end) }} ?
            </h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { cloneDeep } from "lodash";

import moment from "moment-timezone";

import AccountingPeriod from "../AccountingPeriod.vue";
import AccountingPeriodIsDeletable from "./AccountingPeriodIsDeletable.vue";

import DELETE_ACCOUNTING_PERIOD from "../../graphql/accountingPeriod/DeleteAccountingPeriod.gql";
import CHECK_CARRYFORWARDS from "../../graphql/accountingPeriod/CheckCarryForwards.gql";
import ACCOUNTING_PERIODS from "../../graphql/accountingPeriod/AccountingPeriods.gql";

import { User } from "../../store/store";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { State2Way } from "@/decorators";
import {
    getAccountingPeriodsSuiteError,
    getMissingAccountingPeriodLaps,
} from "@/services/accountingPeriods";
import AccountingPeriodsSuiteErrors from "./AccountingPeriodsSuiteErrors.vue";
import AccountingPeriodsMissingLaps from "./AccountingPeriodsMissingLaps.vue";
import { checkAccessRights } from "../../services/accessRightServices";

@Component({
    components: {
        AccountingPeriod,
        AccountingPeriodIsDeletable,
        AccountingPeriodsSuiteErrors,
        AccountingPeriodsMissingLaps,
    },
    emits: ["refresh"],
})
export class AccountingPeriods extends Vue {
    @Prop({ default: null }) companyId: string;
    @Prop({ default: false }) updateStore: boolean;

    @State2Way("updateAccountingPeriods", "accountingPeriod.accountingPeriods")
    accountingPeriodsStore!: [];

    accountingPeriodDialog: boolean = false;
    selectedAccountingPeriod: any = null;

    deleteAccountingPeriodDialog: boolean = false;
    deleteAccountingPeriodLoading: boolean = false;

    accountingPeriodHeaders = [
        { text: "start", value: "start", align: "center", sortable: false },
        { text: "end", value: "end", align: "center", sortable: false },
    ];

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accountingPeriod", "write");
        return authorized;
    }

    get ligthAccountingPeriods() {
        if (this.displayAccountingPeriods?.length) {
            const clonedDAPs = cloneDeep(this.displayAccountingPeriods);

            // ** sorted from more recent to oldest
            const sortedDAPs = clonedDAPs.sort((a, b) => {
                if (a.end < b.end) return 1;
                if (a.end > b.end) return -1;
                return 0;
            });

            return sortedDAPs.map((dap) => ({
                id: dap.id,
                start: dap.start,
                end: dap.end,
                closed: dap.closed,
                temporaryClosed: dap.temporaryClosed,
                isDeletable: dap.isDeletable,
                accountingSituations: dap.accountingSituations,
            }));
        }
        return undefined;
    }

    get selectedAccountingPeriodId() {
        if (this.selectedAccountingPeriod?.id) {
            return this.selectedAccountingPeriod.id;
        }
        return "";
    }

    get accountingPeriodsSuiteErrors() {
        return getAccountingPeriodsSuiteError(this.displayAccountingPeriods);
    }

    get missingAccountingPeriodLaps() {
        return getMissingAccountingPeriodLaps(this.displayAccountingPeriods);
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (190 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD MMMM YYYY");
    }

    refresh(updateStore: boolean = true) {
        if (this.$apollo.queries) {
            if (this.$apollo.queries.checkCarryForwards) {
                this.$apollo.queries.checkCarryForwards.refetch();
            }
            if (this.$apollo.queries.accountingPeriods) {
                this.$apollo.queries.accountingPeriods.refetch();
            }
        }
        // if (updateStore) {
        //     updateStoreUser(this.$apollo, this.$store, this.currentUser.id);
        // }
        this.$emit("refresh");
    }

    addAccountingPeriod() {
        this.selectedAccountingPeriod = null;
        this.accountingPeriodDialog = true;
    }

    openAccountingPeriod(accountingPeriod) {
        this.selectedAccountingPeriod = accountingPeriod;
        if (this.selectedAccountingPeriodId) {
            this.accountingPeriodDialog = true;
        }
    }

    openDeleteAccountingPeriodDialog(accountingPeriod) {
        if (this.isAuthorized) {
            this.selectedAccountingPeriod = accountingPeriod;
            this.deleteAccountingPeriodDialog = true;
        }
    }

    async deleteAccountingPeriod() {
        this.deleteAccountingPeriodLoading = true;
        await this.$apollo.mutate({
            mutation: DELETE_ACCOUNTING_PERIOD,
            variables: {
                id: this.selectedAccountingPeriod.id,
            },
        });
        this.refresh();

        this.deleteAccountingPeriodDialog = false;
        this.deleteAccountingPeriodLoading = false;
    }

    @Apollo({
        query: ACCOUNTING_PERIODS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return this.companyId === "";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.accountingPeriods) {
                    this.accountingPeriods = data.accountingPeriods;
                } else {
                    this.accountingPeriods = [];
                }
                if (this.updateStore) {
                    this.accountingPeriodsStore = this.accountingPeriods;
                }
            }
        },
    })
    accountingPeriods = [];

    @Apollo({
        query: CHECK_CARRYFORWARDS,
        variables() {
            // console.log(this.id)
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.checkCarryForwards?.result) {
                    this.checkCarryForwards = data.checkCarryForwards.result;
                } else {
                    this.checkCarryForwards = null;
                }
            } else {
                this.checkCarryForwards = null;
            }
        },
    })
    checkCarryForwards = null;

    get displayAccountingPeriods() {
        if (!this.accountingPeriods?.length && !this.checkCarryForwards?.length) {
            return [];
        }

        if (this.checkCarryForwards) {
            return this.checkCarryForwards;
        }
        const accountingPeriods = this.accountingPeriods.filter(
            (ap) => !ap?.isAccountingSituationOf,
        );
        return accountingPeriods;
    }

    get selectedCarryForwardDiagnostic() {
        if (this.selectedAccountingPeriod?.id && this.checkCarryForwards) {
            return this.checkCarryForwards.find((ap) => ap.id === this.selectedAccountingPeriod.id);
        }
        return null;
    }

    getPrevAccountingPeriod(accountingPeriod) {
        if (this.checkCarryForwards && accountingPeriod?.prevApId) {
            return this.checkCarryForwards.find((ap) => ap.id === accountingPeriod.prevApId);
        }
        return null;
    }

    autoCarryForwardToDelete(accountingPeriod) {
        if (accountingPeriod?.carryForwardCount) {
            const prevAP = this.getPrevAccountingPeriod(accountingPeriod);
            if (prevAP?.closed) {
                return false;
            }
            return true;
        }
        return false;
    }
}

export default toNative(AccountingPeriods);
</script>
